import { InfoTypeTokens, ColorTokens, SizeTypeTokens, } from '@voltmoney/schema';
export const infoTypeTokenMap = {
    [InfoTypeTokens.SUCCESS]: {
        labelColor: ColorTokens.Grey_Night,
        bgColor: ColorTokens.Success_100,
        fontSize: SizeTypeTokens.SM,
    },
    [InfoTypeTokens.ERROR]: {
        labelColor: ColorTokens.Grey_Charcoal,
        bgColor: ColorTokens.Primary_100,
        fontSize: SizeTypeTokens.XS,
    },
    [InfoTypeTokens.DEFAULT]: {
        labelColor: ColorTokens.Grey_Charcoal,
        bgColor: ColorTokens.Grey_Milk_1,
        fontSize: SizeTypeTokens.XS,
    },
};
